/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type NextGenBoardEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line typescript/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const nextGenBoardEntryPoint: EntryPoint<NextGenBoardEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<NextGenBoardEntryPointComponent>(
			/* webpackChunkName: "async-next-gen-board-entrypoint" */ './BoardSPAApp.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: () => {
			return {};
		},
	});
